export default __webpack_public_path__ + "static/media/african-american-woman.bf74721c.jpg";